import { useEffect } from "react";
import QuizAndResources from "@/components/QuizAndResources";

export default function QuizzesPage() {
  useEffect(() => {
    document.title = "Quizzes & Resources | Sano Acupuncture, Bronx NY";
    let m = document.querySelector('meta[name="description"]');
    if (!m) {
      m = document.createElement("meta");
      m.setAttribute("name", "description");
      document.head.appendChild(m);
    }
    m.setAttribute(
      "content",
      "Three small tools between sessions: the 5-element quiz, the daily body check-in, and the free 7-day Nervous System Reset. From Sano Acupuncture in the Bronx."
    );
  }, []);

  return (
    <main data-testid="quizzes-page">
      <QuizAndResources />
    </main>
  );
}
